export class GPSLocation {

    longitude: number;
    latitude: number;

    constructor(gpsLocation: IGPSLocation) {

        this.longitude = gpsLocation.longitude;
        this.latitude = gpsLocation.latitude;
    }
}

export interface IGPSLocation {

    longitude: number;
    latitude: number;
}